// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
import { useSelector } from 'react-redux';
import { selectUser } from 'redux/slices/userSlice';
import { TenantAuthen } from 'util/Enums';
import styles from './TenantAuthen.module.scss';
import ScanICCardPlugin from 'components/molecules/ScanICCardPlugin';
import { useScanICBarcode } from 'util/hooks/useScanICBarcode';
import QrBarcodeScanner from 'components/atoms/QrBarcodeScanner';

const TennantAuthenPage: React.FC = () => {
  const user = useSelector(selectUser);

  const { onNewScanBarcode, onNewScanICCard } = useScanICBarcode();

  return (
    <div className={styles.tenantAuthen}>
      {user.tenantAuthen === TenantAuthen.Barcode && (
        <QrBarcodeScanner
          onScanSuccess={onNewScanBarcode}
          classNames={{ container: styles.scanner }}
        />
      )}
      {user.tenantAuthen === TenantAuthen.ICCard && (
        <ScanICCardPlugin onScanSuccess={onNewScanICCard} />
      )}
    </div>
  );
};

export default TennantAuthenPage;
